import { InitAppType } from '@multiversx/sdk-dapp/out/methods/initApp/initApp.types';
import { apiTimeout, walletConnectV2ProjectId } from 'config';

export const initAppConfig: InitAppType = {
  dAppConfig: {
    nativeAuth: true,
    network: {
      name: 'customConfig',
      apiTimeout: String(apiTimeout),
      apiAddress: 'https://devnet-api.multiversx.com',
      explorerAddress: 'http://devnet-explorer.multiversx.com'
    },
    providers: {
      walletConnect: {
        walletConnectV2ProjectId
      }
    }
  }
};
